// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"5273d003","703":"0acf96a0"}[chunkId] + ".chunk.js";
};